import { storefrontAiEn } from './storefront.ai.en';
import { storefrontNeedsEn } from './storefront.needs.en';
/** Vitrin arayüz metinleri (en). Vitrinin istemci paketi yalnızca bunu ve ortak/hata metinlerini yükler (F7-17). */
export const storefrontEn = {
  google: {
    or: 'or',
    continue: 'Continue with Google',
    signUpTitle: 'Register with Google',
    newAccount: 'A new account will be created with the Google account {{email}}.',
    name: 'Name: {{name}}',
    noPassword:
      'Your account is created without a password; you can set one any time under My account → Linked accounts.',
    createAccount: 'Create account',
    linkedTitle: 'Linked accounts',
    linked: 'Google: {{email}}',
    setPasswordFirst: 'Set a password before removing the Google link; otherwise you could not sign in.',
    newPassword: 'New password',
    setPassword: 'Set password',
    passwordSet: 'Your password was set.',
    unlink: 'Remove Google link',
    unlinkConfirm: 'Remove the Google link? You will then sign in with your email and password.',
    unlinked: 'Google link removed.',
    reauth: 'Sign in with Google again',
  },
  ai: storefrontAiEn,
  needsFinder: storefrontNeedsEn,
  brands: 'Brands',
  suggest: {
    label: 'Search suggestions',
    groups: { products: 'Products', categories: 'Categories', brands: 'Brands', all: 'All results' },
    all: 'All results for "{{q}}" ({{count}})',
    status: '{{count}} suggestions. Use the down arrow to choose.',
    none: 'No suggestions. Press Enter to search.',
  },
  quick: {
    view: 'Quick view: {{title}}',
    viewShort: 'Quick view',
    add: 'Add to cart: {{title}}',
    addShort: 'Add to cart',
    title: 'Quick view',
    close: 'Close',
    details: 'Go to product page',
    loading: 'Loading…',
    failed: 'Could not load the product. Open the product page.',
  },
  filters: {
    open: 'Filters',
    title: 'Filters',
    close: 'Close',
    form: 'Product filters',
    brand: 'Brand',
    price: 'Price ({{currency}})',
    priceMin: 'Min',
    priceMax: 'Max',
    stock: 'Availability',
    inStockOnly: 'In stock only',
    discount: 'Discount',
    discountedOnly: 'Products on sale',
    active: 'Selected filters',
    remove: 'Remove filter: {{name}}',
    clearAll: 'Clear all',
    below: 'under {{max}}',
    above: '{{min}} and above',
    range: '{{min}}–{{max}}',
    priceChip: 'Price: {{range}}',
    option: '{{label}} ({{count}})',
  },
  preparingTitle: 'Our new store is on its way',
  preparingLead: 'This site is under construction. We will be here when orders open.',
  brandsLabel: 'Our brands',
  contactLater: 'Contact and seller details will be published on this page before launch.',
  unknownDomainTitle: 'There is no store at this address yet',
  unknownDomainLead:
    'The domain reaches the server but is not connected to a store. In the admin panel, open Stores and add this domain.',
  unavailableTitle: 'The store is not responding right now',
  unavailableLead:
    'This may be brief maintenance or a connection problem. Please try again in a few minutes.',
  notFoundTitle: 'Page not found',
  notFoundLead:
    'The address may have changed or the page may have been removed. Search our products or continue with the links below.',
  notFoundSearch: 'Search products',
  notFoundHome: 'Home page',
  goneTitle: 'This page has been removed',
  goneLead: 'The page you are looking for has been permanently removed.',
  maintenanceTitle: 'We are doing a short maintenance',
  maintenanceLead: 'The store will reopen shortly.',
  acceptMembership: 'I have read and accept the membership terms and the privacy notice.',
  acceptSalesTerms: 'I have read and accept the pre-information form and the distance sales contract.',
  activateTitle: 'Activate your account',
  activateLead: 'Hello {{name}}, your account was created by the store. Set your password.',
  resetLead: 'Hello {{name}}, set your new password.',
  addToCart: 'Add to cart',
  buyNow: 'Buy now',
  added: 'Added to cart.',
  all: 'All',
  allProducts: 'All products',
  pageTitleNumbered: '{{title}} – Page {{page}}',
  allSpecies: 'All',
  applicationPending: 'Your dealer application is under review.',
  applicationReceived:
    'Your application was received. We will email you the result; you can also follow it on your account page.',
  applicationRejected: 'Your previous application was not approved.',
  apply: 'Apply',
  applyCoupon: 'Apply',
  applyDealer: 'Dealer application',
  applyLead:
    'If you are a vet clinic, pet shop or pharmacy you can apply as a dealer. Once approved, you will see dealer prices when signed in.',
  applySignInFirst: 'Sign in or create an account to apply.',
  awaitingPaymentNote: 'Your order is awaiting payment.',
  breadcrumb: 'Breadcrumb',
  cart: 'Cart',
  cartEmpty: 'Your cart is empty.',
  cartWithCount: 'Cart, {{count}} items',
  speciesProperty: 'Target species',
  speciesNames: {
    cat: 'Cat',
    dog: 'Dog',
    bird: 'Bird',
    rodent: 'Small rodent',
    rabbit: 'Rabbit',
    reptile: 'Reptile and turtle',
    exotic: 'Other exotic',
  },
  categories: 'Categories',
  changePassword: 'Change password',
  checkout: 'Checkout',
  chooseOption: 'Choose an option.',
  consents: 'Marketing messages',
  privacy: {
    title: 'My personal data',
    lead: 'Use your rights regarding your personal data here. Details:',
    noticeLink: 'Privacy notice',
    exportTitle: 'Download my data',
    exportLead:
      'A copy of your account, addresses, orders, consents and other records is downloaded immediately as a JSON file.',
    password: 'Your password',
    export: 'Download my data',
    exported: 'Your data was downloaded.',
    erasureTitle: 'Delete my account',
    erasureLead:
      'Your erasure request is resolved within 30 days and you are notified by email. Your account is closed; your addresses, favorites and contact details are deleted. Order and invoice records are kept for the legally required period. If you have an open order, the request is resolved after it is delivered.',
    reason: 'Note (optional)',
    understood: 'I understand that my account will be closed and this cannot be undone.',
    requestErasure: 'Send erasure request',
    erasureSent: 'Your erasure request was received. We will email you the result.',
    erasureOpen: 'You have an open erasure request; you will be notified by email when it is resolved.',
    myRequests: 'My requests',
    dueBy: 'by {{date}}',
    kinds: {
      export: 'Copy of data',
      erasure: 'Erasure',
      info: 'Information request',
      rectification: 'Rectification',
      objection: 'Objection',
      other: 'Other',
    },
    statuses: {
      received: 'Received',
      in_progress: 'In progress',
      completed: 'Resolved',
      rejected: 'Not accepted',
    },
  },
  consentsNote: 'Order and shipping notifications are sent regardless of these settings.',
  coupon: 'Coupon code',
  createAccount: 'Create account',
  currentPassword: 'Current password',
  dealerBar: 'Dealer prices are shown ({{company}}).',
  dealerOf: 'You are signed in as a dealer of {{company}} and see dealer prices.',
  dealerPrice: 'Dealer price',
  dealership: 'Dealership',
  discount: 'Discount ({{code}})',
  documents: 'Documents (tax certificate etc.)',
  documentsHint: 'PDF, JPEG or PNG; max 10 MB. Only store staff can see them.',
  email: 'Email',
  emailNotVerified: 'email not verified',
  emailVerified: 'Your email address is verified.',
  feedRegistration: 'Feed registration no: {{no}}',
  feedRegistrationProperty: 'Feed registration number',
  countryRegistration: 'Registration / permit no ({{country}}): {{no}}',
  notInCountry:
    'This product is not for sale in the country you selected. You can choose another country in the top bar.',
  itemNotInCountry: 'This product is not for sale in the selected country; remove it or change the country.',
  marketLabel: 'Country and currency',
  languageLabel: 'Language',
  marketOption: '{{name}} ({{currency}})',
  forSpecies: 'Suitable for: {{list}}',
  forgot: 'Forgot password',
  forgotTitle: 'Forgot password',
  from: 'from',
  fullName: 'Full name',
  goToCart: 'Go to cart',
  homeLead: 'Supplements for cats and dogs.',
  itemInsufficient: 'Only {{count}} in stock.',
  itemUnavailable: 'This product is no longer available; remove it from the cart.',
  leaflet: 'Product information',
  loading: 'Loading…',
  lowStock: 'Only {{count}} left',
  lowest30: 'Lowest price in the last 30 days: {{price}}',
  discountPercent: '{{n}}% off',
  marketingEmail: 'I want to receive campaign emails.',
  marketingLegend: 'Optional marketing consents',
  marketingSms: 'I want to receive campaign SMS.',
  menu: 'Menu',
  mainMenu: 'Main menu',
  faq: 'Frequently asked questions',
  pagePreviewNotice: 'Page preview: you are seeing the unpublished draft. This link is private to you.',
  menuSeeAll: 'All: {{label}}',
  homeCrumb: 'Home',
  qaTitle: 'Questions and answers',
  reviews: {
    title: 'Reviews',
    empty: 'No reviews for this product yet. Customers who bought and received it can write one.',
    count: '{{count}} reviews',
    outOf: '{{value}} out of 5',
    stars: '{{n}} stars',
    distribution: 'Rating distribution',
    verified: 'Verified purchase',
    storeReply: 'Reply from {{store}}',
    by: '{{name}}',
    sort: 'Sort',
    sorts: { newest: 'Newest', rating_desc: 'Highest rating', rating_asc: 'Lowest rating' },
    more: 'Show more reviews',
    write: 'Write a review',
    signIn: 'Sign in to write a review',
    notPurchased: 'You can review this product after buying it from this store and receiving it.',
    alreadyReviewed: 'You have reviewed this product, thank you.',
    rating: 'Your rating',
    ratingNames: { 1: 'Very poor', 2: 'Poor', 3: 'Average', 4: 'Good', 5: 'Excellent' },
    reviewTitle: 'Title',
    optional: 'optional',
    body: 'Your review',
    bodyHint:
      'At least 20 characters. Describe how you used the product; do not include personal data, health claims or disease names. It is published with your first name and last initial after approval.',
    submit: 'Submit review',
    sent: 'Thank you. Your review will be published on the product page after approval.',
  },
  qaEmpty: 'No answered questions about this product yet.',
  qaAsk: 'Ask a question',
  qaLabel: 'Your question',
  qaHint:
    'Your question is published on this page with its answer after review; only a short form of your name is shown. Do not write personal details such as phone or address.',
  qaSubmit: 'Send question',
  qaSentNotify: 'Your question was received. We will email you when it is answered.',
  qaSent: 'Your question was received. It will be published here when answered.',
  qaSignIn: 'Sign in to ask a question',
  qaAsked: 'Asked by {{name}}',
  qaAnswered: 'Answered by {{store}}',
  compare: 'Compare',
  compareTitle: 'Product comparison',
  compareAdd: 'Add to comparison',
  compareRemove: 'Remove from comparison',
  compareFull: 'Up to 4 products can be compared.',
  compareBar: '{{count}} products to compare',
  compareClear: 'Clear list',
  compareEmpty: 'Use the "Add to comparison" button on product pages to compare (up to 4 products).',
  compareShare: 'Share this page address to send the comparison to others.',
  compareMissing: '{{count}} products are no longer on sale and are not shown.',
  compareTable: 'Features of the selected products',
  compareRemoveOne: 'Remove: {{title}}',
  compareScroll: 'Comparison table (scrolls horizontally)',
  compareRows: {
    product: 'Product',
    price: 'Price',
    unitPrice: 'Unit price',
    net: 'Net quantity',
    species: 'Suitable for',
    composition: 'Composition',
    usage: 'Usage',
  },
  netUnits: { g: '{{n}} g', ml: '{{n}} ml', piece: '{{n}} pcs' },
  notSpecified: 'Not specified',
  favoriteAdd: 'Add to favorites',
  favoriteRemove: 'Remove from favorites',
  favoriteLogin: 'Sign in to add favorites',
  favoriteError: 'Could not complete; please try again.',
  favorites: 'My favorites',
  favoritesEmpty: 'No favorites yet. Use the heart button on product cards to add some.',
  favoritesHidden:
    '{{count}} favorite products are not on sale right now; they will reappear here when back.',
  favoritesCount: '{{count}} products',
  favoritesSignIn: 'Sign in to see your favorites.',
  relatedProducts: 'Similar products',
  galleryLabel: 'Product images',
  galleryShow: 'Show image {{n}}',
  galleryZoom: 'Enlarge image',
  galleryClose: 'Close',
  galleryPrev: 'Previous image',
  galleryNext: 'Next image',
  galleryPosition: '{{n}} / {{total}}',
  complementaryProducts: 'Goes well with',
  share: 'Share',
  shareCopied: 'Link copied.',
  shareFailed: 'Could not copy the link; copy it from the address bar.',
  gtin: 'Barcode (GTIN): {{gtin}}',
  installments: 'Up to {{n}} instalments by credit card (depends on card and bank)',
  returnInfo: {
    title: 'Returns',
    days: 'You can return it within {{days}} days of delivery.',
    by_mail: 'Returns are by mail.',
    in_store: 'Returns are in store.',
    by_mail_or_in_store: 'Returns are by mail or in store.',
    free: 'Return shipping is free.',
    customer_pays: 'Return shipping is paid by the buyer.',
    link: 'Return and withdrawal conditions (including exceptions)',
  },
  shippingInfo: {
    title: 'Shipping and delivery',
    free: 'Free',
    price: 'Shipping: {{price}}',
    freeOver: 'Free on orders of {{price}} or more',
    delivery: 'Estimated delivery: {{range}}',
    days: 'Delivery time: {{days}}',
    cod: 'Cash on delivery available',
    note: 'Delivery date is an estimate and may be longer on public holidays. The exact shipping cost is calculated in the cart.',
  },
  tableOfContents: 'Contents',
  videos: {
    play: 'Play video: {{title}}',
    notice: 'The video loads from {{provider}}; {{provider}} may use cookies when you play it.',
    providers: { youtube: 'YouTube', vimeo: 'Vimeo' },
  },
  documentKinds: {
    analysis_certificate: 'Certificate of analysis',
    leaflet: 'Instructions for use',
    safety_data_sheet: 'Safety data sheet',
    registration: 'Registration / approval',
    other: 'Document',
  },
  documentSize: 'PDF, {{size}}',
  subcategories: 'Subcategories',
  relatedCategories: 'Related categories',
  productCategories: 'Categories of this product',
  seoFallback: {
    home: '{{store}}: {{categories}}. Product ingredients, usage information, articles and points of sale.',
    homeNoCategories:
      '{{store}} online shop: product ingredients, usage information, articles and points of sale.',
    products:
      'All {{store}} products: filter by species, category, brand and price; review ingredients and usage information.',
    category:
      '{{name}} — {{store}}. Review the ingredients, usage information and current prices of the products in this category.',
    brand: 'All products of {{name}}: ingredients, usage information and current prices.',
    brands: 'Brands at {{store}} and the products of each brand.',
    blog: '{{store}} articles on pet care and nutrition.',
    contact: 'Contact {{store}}: contact form and seller information.',
    legal: '{{store}} {{title}}: the current version in force.',
    bankAccounts: '{{store}} bank accounts: account and IBAN details for paying by bank transfer.',
  },
  llms: {
    categories: 'Categories',
    pages: 'Pages',
    legal: 'Legal texts',
    products: 'All products',
    articles: 'Articles',
    salesPoints: 'Points of sale',
    contact: 'Contact',
    sitemap: 'Sitemap',
    productList: 'Products',
    articleList: 'Latest articles',
  },
  blog: 'Articles',
  blogEmpty: 'No posts have been published yet.',
  blogAll: 'All',
  blogCategories: 'Article categories',
  blogPages: 'Blog pages',
  blogArchive: 'Archive',
  blogArchiveTitle: 'Article archive: {{period}}',
  blogArchiveCount: 'posts: {{count}}',
  blogArchiveYear: 'Posts from {{year}}',
  readingTime: '{{n}} min read',
  publishedOn: 'Published: {{date}}',
  updatedOn: 'Updated: {{date}}',
  byAuthor: 'By {{name}}',
  postReferences: 'References',
  postProducts: 'Products in this post',
  postTags: 'Tags',
  postHealthNotice:
    'This article is for information only and does not replace examination, diagnosis or treatment. Consult your veterinarian about your pet’s health.',
  postPreviewNotice: 'Post preview: you are seeing the unpublished draft. This link is private to you.',
  allPosts: 'All posts',
  sliderLabel: 'Highlights',
  bannerGridLabel: 'Promotions',
  sliderRole: 'carousel',
  slideRole: 'slide',
  slidePosition: '{{n}} of {{total}}',
  slidePrev: 'Previous slide',
  slideNext: 'Next slide',
  slideGoTo: 'Go to slide {{n}}',
  sliderPause: 'Stop rotation',
  sliderPlay: 'Start rotation',
  announcement: 'Announcement',
  popupClose: 'Close',
  opensInNewTab: '(opens in a new tab)',
  links: 'Links',
  myAccount: 'My account',
  myOrders: 'My orders',
  newPassword: 'New password',
  newest: 'New products',
  next: 'Next',
  prev: 'Previous',
  noOrders: 'You have no orders yet.',
  noPrice: 'This product is not on sale right now.',
  noProducts: 'There are no products here yet.',
  noResults: 'No products match your search.',
  offlinePaymentNote:
    'Online payment is not available yet: your order is placed as "awaiting payment" and the store will contact you about payment.',
  orderNo: 'Order no',
  orderNote: 'Order note (optional)',
  orderPlaced: 'Your order was placed: {{number}}',
  orderPlacedLead: 'The store will contact you about payment and delivery.',
  orderTitle: 'Order {{number}}',
  outOfStock: 'Out of stock',
  pageOf: 'Page {{page}} of {{pages}}',
  pages: 'Pages',
  password: 'Password',
  passwordChanged: 'Your password was changed; other sessions were signed out.',
  passwordHint: 'At least 12 characters; pick a hard-to-guess phrase.',
  birthdayOptional: 'Birthday (optional)',
  birthdayMonth: 'Month',
  birthdayDay: 'Day',
  birthdayHint:
    'Used only to send you a birthday email (if you allow emails); we do not ask for the year. You can leave it empty or remove it at any time.',
  phoneOptional: 'Phone (optional)',
  placeOrder: 'Place order ({{total}})',
  previewNotice: 'Preview: the store is not live yet.',
  themePreviewNotice: 'Theme preview: you are seeing the unpublished draft. Visitors see the live theme.',
  themePreviewExit: 'Exit preview',
  shopBySpecies: 'Shop by species',
  closeMenu: 'Close menu',
  designPreviewNotice:
    'You are previewing design {{variant}} for {{experience}}. Visitors see the published design.',
  designPreviewExit: 'Exit preview',
  designExperiences: {
    header: 'Top menu',
    articles: 'Articles',
    store_locator: 'Store locator',
    needs_finder: "My Pet's Needs",
  },
  articles: {
    featured: 'Featured',
    latest: 'Latest',
    latestArticles: 'Latest articles',
    seeCategory: 'All in {{category}}',
    searchLabel: 'Search articles',
    searchPlaceholder: 'Search articles',
    resultsTitle: 'Articles for "{{q}}"',
    resultCount: '{{count}} articles found',
    noResults: 'No articles match your search. Try another word.',
    allArticles: 'All articles',
    count: '{{count}} articles',
  },
  locator: {
    title: 'Store locator',
    metaDescription:
      'Find dealers and shops that sell our products by province, district and neighbourhood: address, phone, directions and opening hours.',
    cityTitle: 'Stores in {{city}}',
    cityDescription: 'Stores in {{city}} ({{count}}): address, phone, directions and opening hours.',
    districtTitle: 'Stores in {{district}}, {{city}}',
    districtDescription: 'Stores in {{district}}, {{city}} ({{count}}): address, phone and directions.',
    city: 'Province',
    district: 'District',
    neighbourhood: 'Neighbourhood',
    allCities: 'All provinces',
    allDistricts: 'All districts',
    allNeighbourhoods: 'All neighbourhoods',
    chooseCityFirst: 'Choose a province first',
    optionCount: '{{name}} ({{count}})',
    search: 'Search by name or address',
    searchPlaceholder: 'Store name, neighbourhood, street',
    useLocation: 'Use my location',
    geoLocating: 'Getting your location…',
    geoClear: 'Stop sorting by distance',
    geoPrivacy: 'Your location is used only on this device to sort the nearest stores; it is not sent to us.',
    geoOk: 'Nearest stores first. Your location did not leave this device.',
    geoDenied: 'Location permission was not given. You can search by province and district.',
    geoUnavailable: 'Your location could not be determined. You can search by province and district.',
    count: '{{count}} stores',
    results: 'Stores',
    noMatch: 'No stores match your selection.',
    noPoints: 'No stores are listed yet. You can order our products online.',
    clearFilters: 'Clear filters',
    shopOnline: 'Browse products',
    todayOpen: 'Open today: {{hours}}',
    todayClosed: 'Closed today',
    hours: 'Opening hours',
    closed: 'Closed',
    meters: '{{value}} m',
    km: '{{value}} km',
    directions: 'Directions',
    directionsTo: 'Directions to {{name}} (Google Maps, opens in a new tab)',
    mapNote: 'The map is a visual summary; the same information is in the filters and the list.',
    osmAttribution: 'Some locations were found from addresses: © OpenStreetMap contributors',
    allTurkey: 'All of Türkiye',
    showMap: 'Show on map',
    hideMap: 'Hide map',
    byCity: 'By province',
    byDistrict: 'Districts',
    regions: 'Regions',
  },
  product: 'Product',
  products: 'Products',
  profile: 'Profile',
  quantity: 'Quantity',
  register: 'Create account',
  registerTitle: 'Create account',
  remove: 'Remove',
  removeCoupon: 'Remove coupon {{code}}',
  requestNewLink: 'Request a new link.',
  resetSent: 'If an account exists for this email, a link has been sent.',
  resetTitle: 'Set a new password',
  resetUnavailable:
    'Email delivery is not available right now. Please contact the store to reset your password.',
  resultCount: '{{count}} products',
  save: 'Save',
  savePassword: 'Save password',
  saved: 'Saved.',
  search: 'Search',
  searchPlaceholder: 'Search products or ingredients',
  searchResults: 'Results for "{{q}}"',
  sendLink: 'Send link',
  shipping: 'Shipping',
  shippingLater: 'Set at order time',
  signIn: 'Sign in',
  signInTitle: 'Sign in',
  signOut: 'Sign out',
  skipToContent: 'Skip to content',
  sku: 'SKU: {{sku}}',
  sort: 'Sort',
  species: 'Species',
  status: 'Status',
  submitApplication: 'Submit application',
  subtotal: 'Subtotal',
  summary: 'Order summary',
  taxExcluded: 'Excluding VAT',
  taxIncluded: 'Including VAT',
  taxIncludedLine: 'VAT included',
  taxLine: 'VAT',
  total: 'Total',
  unavailableItem: 'Unavailable product',
  verifyTitle: 'Email verification',
  viewOrder: 'View order',
  proceedToCheckout: 'Proceed to checkout',
  shippingAtCheckout: 'Calculated at checkout',
  checkoutTitle: 'Checkout',
  contactTitle: 'Contact details',
  contactLead: 'Order and shipping updates are sent to this address.',
  memberCheckoutHint: 'Have an account? Sign in to see your orders in your account.',
  phone: 'Phone',
  deliveryTitle: 'Delivery address',
  newAddress: 'Enter another address',
  billingTitle: 'Billing details',
  billingSame: 'Billing address is the same as delivery',
  corporateInvoice: 'Invoice to a company',
  shippingTitle: 'Shipping',
  free: 'Free',
  freeOver: 'Free for orders of {{amount}} or more',
  estimatedDays: 'Estimated delivery: {{days}} business days',
  shippingNotAvailable: 'Not available for this cart',
  paymentTitle: 'Payment method',
  installmentsUpTo: 'Up to {{count}} installments',
  codFee: 'Cash on delivery fee',
  codFeeHint: 'Service fee: {{fee}}',
  codMaxHint: 'For orders up to {{amount}}',
  codNotForShipping: 'Not available with the selected shipping',
  creditAvailable: 'Available open-account credit: {{amount}}',
  creditOverdueBlock: 'Open account is unavailable because you have overdue debt ({{amount}}).',
  creditCurrencyBlock: 'Open account is unavailable in this currency.',
  quantityRule: 'Dealer order: at least {{min}}, in multiples of {{step}}.',
  itemBelowMin: 'At least {{min}} required.',
  itemNotMultiple: 'Must be a multiple of {{step}}.',
  minOrderNotMet: 'The dealer minimum order is {{min}}. Add {{missing}} more to order.',
  approval: {
    title: 'The company owner’s approval is needed',
    request: 'Send for the owner’s approval',
    noteLabel: 'Note to the owner (optional)',
    send: 'Send for approval',
    pending:
      'Sent for the owner’s approval on {{date}}; waiting for approval. Changing the cart invalidates the request.',
    withdraw: 'Withdraw request',
    rejected: '{{name}} declined the cart.',
    reason: 'Reason: {{reason}}',
    stale: 'The cart changed after it was sent for approval; send the current cart again.',
    approved:
      '{{name}} approved this cart on {{date}}. You can complete the order as long as the cart stays unchanged.',
    note: 'Note: {{note}}',
    ownerTitle: 'Orders awaiting approval',
    ownerLead:
      'Buyers’ carts above their order threshold. The buyer places the approved cart from their checkout.',
    nonePending: 'No orders are waiting for approval.',
    requestOf: 'Approval request from {{name}}',
    goodsTotal: 'Goods total: {{total}}',
    requestNote: 'Note: {{note}}',
    approve: 'Approve',
    reject: 'Decline',
    rejectReason: 'Reason for declining',
    rejectSubmit: 'Decline with reason',
    approvedDone: '{{name}}’s cart was approved.',
    rejectedDone: '{{name}}’s cart was declined.',
    history: 'Decided requests',
    requester: 'Requested by',
    statuses: {
      pending: 'Waiting',
      approved: 'Approved',
      rejected: 'Declined',
      cancelled: 'Withdrawn',
      used: 'Ordered',
    },
    orderLine: 'Company approval: {{name}}',
  },
  po: {
    title: 'Purchase order (PO)',
    lead: {
      none: 'Optional: you can add your company’s purchase order number and document.',
      number: 'Your company requires a purchase order (PO) number on orders.',
      number_and_document: 'Your company requires a purchase order (PO) number and document on orders.',
    },
    number: 'PO number',
    numberOptional: 'PO number (optional)',
    document: 'PO document',
    documentOptional: 'PO document (optional)',
    documentHint: 'PDF, JPEG or PNG; up to 10 MB. Only the store can see the document.',
    uploaded: '{{name}} attached.',
    remove: 'Remove',
    missing: 'Complete the purchase order details to confirm the order.',
    listLabel: 'PO: {{number}}',
    orderLine: 'Purchase order: {{number}}',
    orderDocument: 'document: {{name}}',
  },
  quotes: {
    title: 'Quotes',
    linkLead: 'Price quotes you requested or received',
    detailTitle: 'Quote {{number}}',
    empty: 'No quotes yet. Use "Request a quote" in the cart to ask for a price.',
    number: 'Quote no',
    validUntil: 'Valid until',
    validUntilLine: 'valid until {{date}}',
    versionLine: 'version {{version}}',
    statuses: {
      requested: 'Request received',
      draft: 'Being prepared',
      sent: 'Awaiting your answer',
      ordered: 'Ordered',
      rejected: 'Declined',
      cancelled: 'Cancelled',
      expired: 'Expired',
    },
    requestedLead: 'Your request was received. The quote appears here once the store sends it.',
    draftLead: 'The store is preparing or updating the quote; you can accept it once it is sent.',
    rejectedLead: 'You declined the quote: {{reason}}',
    expiredLead: 'The quote has expired and cannot be accepted. Contact the store for a new one.',
    note: 'Store note',
    requestNoteLine: 'Your note: {{note}}',
    lines: 'Quoted products',
    product: 'Product',
    listPrice: 'List price',
    unitPrice: 'Quote price',
    taxIncl: 'VAT included',
    taxExcl: 'VAT excluded',
    taxLine: 'VAT: {{tax}}',
    saving: 'Discount vs list price: {{amount}}',
    shippingNote: 'Shipping and payment are chosen when ordering.',
    accept: 'Accept and order',
    acceptLead:
      'Accepting replaces your cart with this quote (other items are removed) and takes you to checkout; prices follow the quote.',
    reject: 'Decline',
    rejectReason: 'Reason',
    confirmReject: 'Decline quote',
    print: 'Print',
    view: 'View quote',
    inCart:
      'The cart holds quote {{number}} (version {{version}}, valid until {{date}}). Prices follow the quote; the cart cannot be changed.',
    release: 'Remove quote from cart',
    request: 'Request a quote',
    requestLead:
      'Ask the store for a special price for the items in your cart. Your cart stays the same; the quote appears under My account → Quotes.',
    requestNote: 'Your note (optional)',
    sendRequest: 'Send quote request',
    requested: 'Quote request {{number}} received.',
  },
  quickOrder: {
    title: 'Quick order',
    linkLead: 'Bulk order by SKU and quantity',
    lead: 'Write one SKU and quantity per line (e.g. "ZG-OM-60;12"). You can paste two columns from Excel or choose a CSV file. Check first; valid lines are added to the cart.',
    lines: 'SKU and quantity (one product per line)',
    file: 'or choose a CSV file',
    check: 'Check',
    addToCart: 'Add {{count}} products to cart',
    preview: 'Check result',
    sku: 'SKU',
    product: 'Product',
    unitPrice: 'Unit price',
    ok: 'Can be added',
    added: '{{count}} products added to the cart.',
    empty: 'No readable lines. Write a SKU and quantity on each line.',
    badLines: 'Unreadable lines skipped: {{lines}} (quantity must be 1–999).',
    dealersOnly: 'Quick order is available to dealer accounts.',
    statuses: {
      not_found: 'SKU not found',
      unavailable: 'Not on sale',
      insufficient_stock: 'Not enough stock (up to {{available}})',
      below_min_quantity: 'At least {{min}}',
      not_pack_multiple: 'Multiples of {{step}}',
      cart_line_limit: 'The cart holds up to {{max}} different products',
    },
  },
  reorder: {
    title: 'Reorder',
    button: 'Reorder this order',
    added: '{{count}} products added to the cart at today’s prices.',
  },
  companyLocation: 'Company: {{label}}',
  companyInvoiceNote: 'The invoice is issued with the company name, tax office and tax number.',
  memberLimit:
    'Your order threshold: {{amount}} (shipping included). Orders above it need the company owner’s approval.',
  company: {
    title: 'My company',
    roles: { owner: 'Owner', buyer: 'Buyer', viewer: 'View only' },
    roleHelp: {
      owner:
        'You order for the company, see company orders, the account statement and users, and manage locations.',
      buyer: 'You order for the company and see your own orders.',
      viewer: 'You see dealer prices, company orders and the account statement; you cannot order.',
    },
    locations: 'Locations (branch, delivery, billing)',
    noLocations: 'No locations yet.',
    addLocation: 'Add location',
    editLocation: 'Edit location',
    edit: 'Edit',
    delete: 'Delete',
    confirmDelete: 'Delete the "{{name}}" location? Addresses on past orders do not change.',
    deleted: 'Location deleted.',
    saved: 'Location saved.',
    locationLabel: 'Location name (e.g. Head office)',
    defaultShipping: 'default delivery',
    defaultBilling: 'default billing',
    makeDefaultShipping: 'Make default delivery address',
    makeDefaultBilling: 'Make default billing address',
    saveLocation: 'Save location',
    members: 'Company users',
    membersLead:
      'To add someone who already has an account in the store, or to change your own role, contact the store.',
    memberName: 'User',
    role: 'Role',
    limit: 'Order threshold',
    notActivated: 'not activated yet',
    actions: 'Actions',
    you: '(you)',
    memberEdit: 'Edit',
    memberEditFor: 'Edit: {{name}}',
    memberFormFor: '{{name}}: role and threshold',
    memberSave: 'Save',
    memberSaved: '{{name}} updated.',
    remove: 'Remove from company',
    removeFor: 'Remove from company: {{name}}',
    removeConfirm:
      "Remove {{name}} from the company? Their account isn't deleted, but they will no longer see dealer prices or company details.",
    removed: '{{name}} was removed from the company.',
    resendLink: 'Resend link',
    resendLinkFor: 'Resend link: {{name}}',
    linkResent: 'A new activation link was sent to {{email}}; the previous link no longer works.',
    limitField: 'Order threshold (TRY)',
    limitHint: 'Carts above this amount come to you for approval. Leave empty for no threshold.',
    limitInvalid: 'Enter the amount like 5000 or 2500.50.',
    inviteTitle: 'Invite a user',
    inviteLead:
      'The invited person gets an activation link by email and sets their own password. You can send up to {{perDay}} invitations a day.',
    inviteName: 'Full name',
    inviteEmail: 'Email',
    invitePhone: 'Phone (optional)',
    inviteSubmit: 'Send invitation',
    invited: 'Invitation sent to {{email}}.',
    inviteSetupRequired:
      "Setup required: invitations can't be sent yet because the store's email service isn't set up. To add users, contact the store.",
    orders: 'Company orders',
    placedBy: 'Placed by',
    companyOrderNote:
      'This order belongs to another user of your company; you can only view it. Returns and payments are handled by the person who placed it.',
  },
  balancePay: {
    open: 'Pay by card',
    title: 'Pay balance by card',
    modeBalance: 'Full balance ({{amount}})',
    modeItems: 'Selected items',
    modeCustom: 'Another amount',
    itemLabel: '{{item}} — {{amount}}',
    amountLabel: 'Amount ({{currency}})',
    amountHint: 'You can pay at most {{max}}.',
    amountInvalid: 'Enter the amount like 1,250.50.',
    lead: "The payment is taken on the payment provider's secure page (up to {{installments}} instalments). It is recorded on your account and applied to your oldest due debt.",
    submit: 'Pay {{amount}}',
    unavailable: 'Card payment is not available right now. You can pay your balance by bank transfer.',
    recent: 'Your recent card payments',
    amount: 'Amount',
    status: 'Status',
    statuses: {
      pending: 'Pending',
      captured: 'Received',
      failed: 'Failed',
      expired: 'Expired',
      requires_action: 'Under review',
    },
    resultTitle: 'Account payment',
    notFound: 'Payment not found.',
    result: {
      pending: 'Checking your payment…',
      captured: 'Your payment of {{amount}} was received and recorded on your account.',
      failed: 'The payment failed. Your card was not charged; you can try again.',
      expired: 'The payment was not completed. Your card was not charged; you can try again.',
      requires_action:
        'Your payment is under review. The result will appear on your account; we will contact you if needed.',
    },
    backToAccount: 'Back to my account',
  },
  dealerLedger: {
    bhPendingPayments: 'Your payments not yet in the accounting record',
    bhPending: 'Orders not yet in our accounts',
    bhSource: 'Balance and movements from our accounting record (BizimHesap), last updated {{date}}.',
    bhNever: 'The accounting record (BizimHesap) has not been fetched yet.',
    bhStale: 'Could not update right now; showing the last record received.',
    bhStatement: 'Account statement (accounting record)',
    siteStatement: 'Order and payment movements on this site',
    title: 'My account statement',
    lead: 'Open-account orders are due {{days}} days after the order date. Payments are applied to the oldest due amount first.',
    leadNoTerm: 'Payments are applied to the oldest due amount first.',
    balance: 'Balance (amount you owe)',
    overdue: 'Overdue',
    available: 'Available open-account limit',
    openItems: 'Unpaid items',
    item: 'Order / entry',
    dueDate: 'Due date',
    open: 'Remaining',
    daysOverdue: '{{days}} days overdue',
    statement: 'Statement (last 12 months)',
    date: 'Date',
    description: 'Description',
    debit: 'Debit',
    credit: 'Credit',
    running: 'Balance',
    broughtForward: 'Brought forward',
    download: 'Download statement (CSV)',
    kinds: {
      order: 'Order',
      order_change: 'Order change',
      order_payment: 'Order payment',
      payment: 'Payment',
      opening: 'Opening balance',
      adjustment: 'Adjustment',
      reversal: 'Correction (reversal)',
    },
    reasons: {
      placed: 'Order placed',
      cancelled: 'Cancelled',
      partial_cancel: 'Partly cancelled',
      edited: 'Order edited',
      refunded: 'Refund',
      paid: 'Payment received',
      refund_paid: 'Refund paid',
      changed: 'Amount changed',
      card_balance: 'Card payment',
    },
  },
  contractsTitle: 'Pre-information and contract',
  contractsLead:
    'Read the texts below before confirming. The texts you accept are stored with your order; you can always see them on your order page.',
  fillToSeeContracts:
    'Totals and contract texts appear here once you choose the address, shipping and payment method.',
  quoteUpdating: 'Updating totals…',
  confirmAndPay: 'Confirm and pay · {{total}}',
  confirmOrder: 'Confirm order · {{total}}',
  placingOrder: 'Placing your order…',
  orderReceivedTitle: 'Your order was received',
  orderReceivedLead: 'Your order number is {{number}}.',
  customerService: 'Customer service',
  contactPageTitle: 'Contact',
  contactForm: {
    title: 'Write to us',
    presets: {
      name: 'Your full name',
      email: 'Your email address',
      phone: 'Phone',
      message: 'Your message',
    },
    submit: 'Send',
    sent: 'Your message was received. We will reply by email as soon as possible.',
    trap: 'Leave this field empty',
  },
  formChoose: 'Choose',
  formPrivacy: 'Your personal data is processed only to answer your request. Details:',
  phoneLabel: 'Phone',
  emailLabel: 'Email',
  contactOrderHint: 'If you are writing about an order, include your order number. To view your order:',
  orderLookupTitle: 'Order lookup',
  stockAlert: {
    open: 'Notify me when available',
    lead: 'We will email you once when this option is back in stock. No account needed.',
    email: 'Email',
    notice:
      'Your address is used only for this notice; one email is sent when the product is back in stock and the request is valid for 6 months. No advertising is sent.',
    submit: 'Notify me',
    sent: 'Done. We will email you when the product is back in stock.',
  },
  tender: {
    title: 'Gift card or store credit',
    giftCard: 'Gift card code',
    apply: 'Apply',
    remove: 'Remove card',
    applied: 'Gift card …{{last4}} applied (balance {{balance}}).',
    useCredit: 'Use my store credit ({{balance}})',
    coveredHint: 'If the full amount is covered, the selected payment method is not used.',
    giftCardLine: 'Gift card (…{{last4}})',
    storeCreditLine: 'Store credit',
    due: 'Amount to pay',
    confirmCovered: 'Confirm order (nothing left to pay)',
  },
  credit: {
    title: 'My store credit',
    lead: 'Use your store credit at checkout with "Use my store credit".',
    history: 'Store credit history',
    date: 'Date',
    kind: 'Activity',
    amount: 'Amount',
    kinds: {
      grant: 'Added by the store',
      refund: 'Refund added as credit',
      redeem: 'Used in an order',
      release: 'Returned from a cancelled order',
      adjust: 'Adjustment',
    },
  },
  loyalty: {
    tierLine: '{{tier}} member discount ({{percent}}%)',
    tierShipping: '{{tier}} membership: free shipping',
    usePoints: 'Use my points ({{points}} points = {{value}})',
    minRedeem: 'You need at least {{points}} points to use them (you have {{balance}}).',
    pointsLine: 'Loyalty points ({{points}} points)',
    earn: 'You will earn {{points}} points from this order; they are added {{days}} days after delivery.',
    earnNow: 'You will earn {{points}} points from this order; they are added after delivery.',
    title: 'My points',
    balance: '{{points}} points',
    balanceValue: 'Worth {{value}}; use them at checkout with "Use my points".',
    tier: 'Your tier: {{tier}}',
    noTier: 'You do not have a tier yet.',
    perks: 'Your benefits: {{perks}}',
    perkDiscount: '{{percent}}% discount',
    perkShipping: 'free shipping',
    nextTier: '{{amount}} more to reach {{tier}} ({{spent}} spent in the last 12 months).',
    topTier: 'You are at the top tier ({{spent}} spent in the last 12 months).',
    expiring: '{{points}} points expire within 30 days.',
    rules: 'Program terms',
    ruleEarn:
      'You earn {{points}} points for every {{one}} spent (excluding shipping and the part paid with points).',
    ruleValue: '{{points}} points = {{one}}.',
    ruleHold: 'Points are added {{days}} days after delivery.',
    ruleHoldNow: 'Points are added after delivery.',
    ruleExpiry: 'Earned points are valid for {{months}} months; points expiring first are used first.',
    ruleNoExpiry: 'Points do not expire.',
    ruleMin: 'At least {{points}} points are needed to use them at checkout.',
    ruleRefund: 'Points for refunded amounts are taken back; points used on a cancelled order are restored.',
    tiersTitle: 'Tiers (by spending in the last 12 months)',
    tierRow: '{{tier}}: {{min}} or more',
    history: 'Points history',
    date: 'Date',
    kind: 'Type',
    points: 'Points',
    kinds: {
      earn: 'Earned',
      redeem: 'Used in order',
      release: 'Restored',
      reverse: 'Taken back (refund)',
      expire: 'Expired',
      adjust: 'Adjustment',
    },
  },
  referral: {
    title: 'Invite a friend',
    lead: 'A friend who places their first order with your invite code gets {{friend}}. {{days}} days after your friend’s order is delivered, you receive a {{referrer}} coupon.',
    leadNow:
      'A friend who places their first order with your invite code gets {{friend}}. Once your friend’s order is delivered, you receive a {{referrer}} coupon.',
    offerPercent: '{{percent}}% off',
    offerFixed: '{{value}} off',
    offerMin: '{{offer}} (on orders of {{min}} or more)',
    getCode: 'Get my invite code',
    yourCode: 'Your invite code:',
    link: 'Your invite link',
    copy: 'Copy link',
    share: 'Share',
    shareTitle: 'My invite link for a first-order discount',
    copied: 'Link copied.',
    copyFailed: 'Could not copy; select the link and copy it yourself.',
    stats: 'Pending invites: {{pending}}. Rewards earned: {{rewarded}}.',
    rules: 'Programme terms',
    ruleFirst: 'The discount applies only to your friend’s first order. You cannot use your own code.',
    ruleHold:
      'The reward is issued {{days}} days after your friend’s order is delivered. No reward if the order is cancelled or returned.',
    ruleHoldNow:
      'The reward is issued once your friend’s order is delivered. No reward if the order is cancelled or returned.',
    ruleValid: 'The reward coupon is valid for {{days}} days and can only be used on your account.',
    ruleMax: 'You can earn up to {{max}} rewards.',
    ruleNoContact: 'The shop never messages your friend on your behalf; you share the link yourself.',
    rewardsTitle: 'Your reward coupons',
    code: 'Code',
    discount: 'Discount',
    endsAt: 'Expires',
    state: 'Status',
    states: { active: 'Available', used: 'Used', expired: 'Expired' },
    inviteTitle: 'You are invited',
    inviteLead: 'A friend has invited you. You get {{offer}} on your first order.',
    inviteCode: 'Invite code:',
    inviteHow:
      'The code is applied to your cart automatically; you can also type it into the "Coupon code" field in the cart. The discount applies to the first order only.',
    inviteStart: 'Start shopping',
  },
  support: {
    title: 'My support requests',
    empty: 'You have no support requests yet.',
    newTicket: 'New request',
    colTicket: 'Request',
    colStatus: 'Status',
    colUpdated: 'Last update',
    category: 'Topic',
    subject: 'Subject',
    order: 'Related order (optional)',
    noOrder: 'No order',
    message: 'Your message',
    messageHint: 'Do not write card numbers, passwords or verification codes; we never ask for them.',
    submit: 'Send request',
    cancel: 'Cancel',
    categories: {
      order: 'Order',
      shipping: 'Shipping and delivery',
      return: 'Returns and exchanges',
      payment: 'Payment and invoice',
      product: 'Product information',
      account: 'Account',
      other: 'Other',
    },
    statuses: {
      open: 'Under review',
      waiting: 'Awaiting your reply',
      resolved: 'Resolved',
      closed: 'Closed',
    },
    awaitingRating: 'Please rate our help',
    ticketTitle: 'Support request #{{number}}',
    orderLine: 'Order {{number}}',
    conversation: 'Conversation',
    you: 'You',
    team: 'Support team',
    resolvedNote:
      'Your request was marked as resolved. If the problem continues, just write; the request will be reopened.',
    closedNote: 'This request is closed. For a new topic, open a new request from My account.',
    reply: 'Your reply',
    sendReply: 'Send reply',
    replySent: 'Your reply was sent.',
    rateTitle: 'Rate our help',
    rateLead: 'Choose a score from 1 (not satisfied at all) to 5 (very satisfied).',
    score: '{{score}} points',
    comment: 'Your comment (optional)',
    sendRating: 'Send rating',
    ratingSent: 'Thank you, your rating was received.',
    thanks: 'Thank you for your rating: {{rating}} / 5',
    notFound:
      'Request not found. Make sure you used the full link in the email; if you are a member, sign in.',
    keepLink: 'The link to this page is personal; do not share it.',
  },
  chat: {
    launcher: 'Live support',
    title: 'Live support',
    close: 'Close',
    unavailable: 'Live support is closed right now. You can write to us on the contact page:',
    nobody: 'No agent is online right now. You can write to us on the contact page:',
    sent: 'Your message was received and saved as a support request. We will reply to your email address.',
    startLead: 'Type your question; an agent will reply shortly.',
    offlineLead: 'No agent is online right now. Leave a message and we will reply by email.',
    nameOptional: 'Your name (optional)',
    name: 'Your name',
    emailOptional: 'Email (optional)',
    email: 'Email',
    emailHint: 'If the chat is interrupted, we can get back to you at this address.',
    emailOfflineHint: 'We will reply to this address.',
    message: 'Your message',
    privacy:
      'Do not write card numbers, passwords or verification codes. What you write is processed only to answer your question:',
    start: 'Start chat',
    leave: 'Send message',
    messages: 'Chat messages',
    team: 'Support team',
    you: 'You',
    events: {
      joined: 'An agent joined the chat.',
      closed_visitor: 'You ended the chat.',
      closed_staff: 'The agent closed the chat.',
      closed_idle: 'The chat was closed due to inactivity.',
      ticket: 'Your chat was saved as a support request; we will get back to you by email.',
    },
    waiting: 'You are number {{position}} in the queue; an agent will connect shortly.',
    closedTicket: 'The chat has ended; your topic was saved as a support request.',
    closed: 'The chat has ended.',
    newChat: 'New chat',
    yourMessage: 'Your message',
    send: 'Send',
    end: 'End chat',
  },
  promo: {
    title: 'Promotions',
    itemDiscount: '{{percent}}% off in your cart',
    buyXPayY: 'Buy {{buy}} pay {{pay}}: for every {{buy}} items, the lowest-priced {{free}} free',
    tierSubtotalPercent: '{{percent}}% off carts of {{min}} or more',
    tierSubtotalFixed: '{{value}} off carts of {{min}} or more',
    tierQuantityPercent: '{{percent}}% off when you buy {{min}} or more items',
    tierQuantityFixed: '{{value}} off when you buy {{min}} or more items',
    freeShippingOver: 'Free shipping on orders of {{min}} or more',
    freeShipping: 'Free shipping',
    until: 'Until {{date}}',
    targeted: 'The promotion applies to this product; the discount is applied in your cart.',
    hintPercent: 'Add {{amount}} more to get {{percent}}% off your cart.',
    hintFixed: 'Add {{amount}} more to get {{value}} off your cart.',
    hintShipping: 'Add {{amount}} more for free shipping.',
    shippingFree: 'Free shipping',
    coupon: 'Coupon ({{code}})',
  },
  push: {
    title: 'Browser notifications',
    lead: 'Hear about campaigns and new products by notification. Permission is asked only when you press the button; turn it off any time.',
    enable: 'Turn on notifications',
    disable: 'Turn off notifications',
    enabled: 'Notifications are on in this browser.',
    disabled: 'Notifications turned off.',
    denied:
      'Your browser blocks notifications for this site. Change the site permission in browser settings to turn them on.',
    failed: 'Notifications could not be turned on. Try again later.',
    privacy: 'Privacy notice',
  },
  newsletter: {
    title: 'Email newsletter',
    lead: 'Hear about offers, new products and articles. Unsubscribe with one click at any time.',
    email: 'Your email address',
    consent:
      'I agree to receive commercial electronic messages by email about offers, announcements and news.',
    privacy: 'Privacy notice',
    submit: 'Subscribe',
    sent: 'Thank you. Open the link we sent to your email address to start the subscription (valid for 7 days). Check your spam folder if it does not arrive.',
    confirmTitle: 'Confirm your newsletter subscription',
    confirmLead: 'Press the button below to allow us to send the newsletter to this address.',
    confirm: 'Confirm subscription',
    confirmed:
      'Your subscription has started. You can unsubscribe at any time with the link at the bottom of every newsletter.',
    missingToken: 'The link is incomplete. Open the full link from the email.',
    unsubscribeTitle: 'Unsubscribe from marketing messages',
    unsubscribeLead: 'We will stop sending marketing messages to {{address}}.',
    unsubscribeLeadSms: 'We will stop sending marketing text messages to {{address}}.',
    unsubscribe: 'Unsubscribe',
    unsubscribed:
      'Done: we will no longer send marketing messages to {{address}}. Order and shipping notifications continue.',
    memberHint:
      'If you have an account you can also change your preferences under the message preferences on My account.',
  },
  orderLookupLead:
    'Enter your order number and the email address used for the order. If they match, your order link is sent to your email.',
  orderLookupMember: 'If you ordered as a member, you can see your orders in your account:',
  orderNumber: 'Order number',
  orderLookupSubmit: 'Send the link',
  orderLookupSent:
    'If the details match an order, the order link will arrive in your email within a few minutes. If not, check your spam folder.',
  orderLookupUnavailable:
    'Email cannot be sent right now. Please contact us using the details on the contact page.',
  bankAccountsTitle: 'Our bank accounts',
  bankAccountsLead: 'Write your order number (or dealer code) in the transfer description.',
  bankAccountsEmpty: 'No bank account details have been added yet.',
  returnsTitle: 'Returns, withdrawal and exchange',
  returnLead:
    'To return an item or use your right of withdrawal, create a request; we will review it and reply by email. Terms:',
  returnPolicyLink: 'Returns and withdrawal terms',
  returnStart: 'Create a return / withdrawal request',
  returnStartExchange: 'Create a return, withdrawal or exchange request',
  returnResolution: 'What would you like?',
  returnResolutions: {
    refund: 'A refund',
    exchange: 'An exchange (another option of the same product)',
  },
  exchangeHint:
    'Exchanges use options at the same price that are in stock; there is no extra charge. For an option at a different price, request a return and place a new order.',
  exchangeItemsLabel: 'Items to exchange, quantity and the option you want instead',
  exchangeFor: 'Option you want instead of {{title}}',
  exchangeChoose: 'Choose an option',
  exchangeItems: 'Sending instead: {{items}}',
  exchangeShipped: 'The exchange item has shipped. Tracking number: {{number}}',
  cancelledQty: '{{count}} could not ship and was cancelled',
  cancelledItems: 'Cancelled items',
  chooseProvince: 'Choose a province',
  chooseDistrict: 'Choose a district',
  chooseProvinceFirst: 'Choose a province first',
  returnKind: 'Request type',
  returnItems: 'Items and quantities to return',
  returnQuantityFor: 'Quantity of {{title}} to return',
  returnNote: 'Note (optional)',
  returnSubmit: 'Send request',
  returnSent:
    'Your request was received. We will email you after reviewing it; please wait for our reply before sending the item.',
  returnKinds: {
    withdrawal: 'Right of withdrawal (changed my mind)',
    defective: 'Damaged / defective item',
    wrong_item: 'Wrong item sent',
    other: 'Other',
  },
  returnStatuses: {
    requested: 'Under review',
    approved: 'Approved',
    rejected: 'Not accepted',
    completed: 'Completed',
    cancelled: 'Cancelled',
  },
  bankTransferTitle: 'Bank transfer details',
  bankTransferLead:
    'Please transfer {{amount}} to one of the accounts below and write your order number in the description. Your order is prepared once the payment arrives.',
  bankTransferDeadline:
    'If your payment has not reached our account by {{deadline}}, your order is cancelled automatically.',
  bank: 'Bank',
  accountHolder: 'Account holder',
  iban: 'IBAN',
  transferDescription: 'Description',
  copy: 'Copy',
  copied: 'Copied',
  payRedirecting: 'Redirecting to the secure payment page…',
  payFrameTitle: 'Secure payment',
  payFrameMissing:
    'The card payment form could not be opened (it may have expired or been opened in another tab). Look up your order to start the payment again.',
  payFrameLead: "Card details are entered in the payment provider's secure form; the store never sees them.",
  payFrameReturn: 'Continue to see the payment result',
  paymentInitFailed: 'The payment page could not be opened. Your order is saved; you can try again.',
  retryPayment: 'Try payment again',
  paymentResultTitle: 'Payment result',
  paymentChecking: 'Checking your payment…',
  paymentSuccess: 'Payment received. Your order is being prepared.',
  paymentAuthorized: 'Your order is confirmed.',
  paymentAuthorizedLead:
    'The total of order {{number}} is held on your card and will be charged when the items ship.',
  preauthNote:
    'The amount is held on your card now and charged when the items ship. Single payment; may not work with debit cards.',
  paymentFailed: 'Payment could not be completed.',
  paymentReview:
    'Your payment is under review by the payment provider. The result will appear on your order page.',
  paymentPendingLong: 'No payment result yet. Check your order page in a few minutes.',
  paymentExpired: 'The payment time expired; the order was cancelled.',
  orderNotFound: 'Order not found. Open the link exactly as in your email or sign in to your account.',
  keepOrderLink: 'Keep the link to this page: you can track your order with it.',
  trackOrder: 'Track order',
  paymentLabel: 'Payment',
  shipmentTitle: 'Shipment tracking',
  trackingNumber: 'Tracking number: {{number}}',
  trackShipment: 'Track shipment',
  partialShipmentNote:
    'Part of your order has shipped. The remaining items will be sent in a separate package; we will email you when it ships.',
  shipmentItems: 'In this package: {{items}}',
  documentsTitle: 'Texts you accepted',
  sellerInfo: 'Seller information',
  mersis: 'MERSIS: {{no}}',
  kep: 'KEP: {{address}}',
  paymentSecureIyzico: 'Payments are processed securely by iyzico',
  etbis: 'Registered with ETBİS (click to verify)',
  etbisQr: 'ETBİS registration QR code',
  consent: {
    title: 'Cookie preferences',
    lead: 'We always use the cookies the site needs to work. With your permission we also use cookies to measure visits (analytics) and to show ads that match your interests (marketing). You can change your choice at any time with the "Cookie preferences" link at the bottom of the page.',
    policyLink: 'Cookie Policy',
    acceptAll: 'Accept all',
    rejectAll: 'Reject',
    preferences: 'Preferences',
    save: 'Save my choices',
    close: 'Close',
    necessary: 'Necessary cookies',
    necessaryLead: 'For the cart, sign-in, security and remembering this choice. Cannot be turned off.',
    alwaysOn: 'Always on',
    analytics: 'Analytics cookies',
    analyticsLead: 'Help us measure how the site is used.',
    marketing: 'Marketing cookies',
    marketingLead: 'To measure ads and show ads that match your interests.',
    providers: 'Services: {{list}}.',
    providerNames: {
      gtm: 'Google Tag Manager',
      ga4: 'Google Analytics',
      googleAds: 'Google Ads',
      meta: 'Meta (Facebook, Instagram) pixel',
      tiktok: 'TikTok pixel',
    },
    transferNote:
      'The providers of these services may process data outside Türkiye. See the Cookie Policy and Privacy Notice for details.',
    error: 'Your choice could not be saved. Please try again.',
    footerLink: 'Cookie preferences',
  },
  legalFallbackNote: 'This document has not been published in English yet; the Turkish version is shown.',
  legalTemplatedNote:
    'This is a sample. During checkout it is filled with your order details and emailed to you.',
  unitPrice: 'Unit price: {{price}} / {{unit}}',
  orderShippingMethod: 'Shipping: {{name}}',
  billingAddress: 'Billing address',
  shippingAddress: 'Delivery address',
  cardSummary: '{{brand}} ···· {{last4}}',
  installmentCount: '{{count}} installments',
  awaitingTransferNote: 'Your order is awaiting the bank transfer.',
  awaitingCardNote: 'Your order is awaiting card payment.',
  checkoutBlocked: 'Orders cannot be placed right now',
  address: {
    fullName: 'Recipient name',
    phone: 'Phone',
    line1: 'Address',
    district: 'District',
    city: 'City',
    postalCode: 'Postal code (optional)',
    companyName: 'Company name',
    taxOffice: 'Tax office',
    taxNumber: 'Tax / ID number',
    cityAbroad: 'City',
    districtAbroad: 'State / region (optional)',
    abroadNote:
      'Delivery country: {{country}}. To ship to another country, change the country at the top of the page.',
  },
  dealerFields: {
    legalName: 'Legal company name',
    tradeName: 'Trade name (optional)',
    taxOffice: 'Tax office',
    taxNumber: 'Tax no / national ID',
    phone: 'Business phone',
    city: 'City',
    district: 'District (optional)',
    address: 'Full address',
    businessType: 'Business type (e.g. vet clinic)',
    note: 'Anything to add (optional)',
  },
  leafletSections: {
    description: 'About the product',
    specs: 'Specifications',
    videos: 'Videos',
    documents: 'Documents',
    composition: 'Composition',
    usage: 'Directions for use',
    warnings: 'Warnings',
  },
  orderStatuses: {
    draft: 'Draft',
    awaiting_payment: 'Awaiting payment',
    paid: 'Paid',
    processing: 'Processing',
    shipped: 'Shipped',
    delivered: 'Delivered',
    completed: 'Completed',
    cancelled: 'Cancelled',
  },
  sorts: {
    relevance: 'Best match',
    newest: 'Newest',
    price_asc: 'Price (low to high)',
    price_desc: 'Price (high to low)',
    name: 'By name',
  },
  paymentMethods: {
    card: 'Credit/debit card',
    paypal: 'PayPal',
    bank_transfer: 'Bank transfer',
    cash_on_delivery: 'Cash on delivery',
    open_account: 'Open account',
    manual: 'Transfer / cash (agreed with the store)',
    gift_card: 'Gift card',
    store_credit: 'Store credit',
    loyalty_points: 'Loyalty points',
  },
  paymentMethodHints: {
    card: "Card details are entered on the payment provider's secure page.",
    paypal: 'Pay with your PayPal account on PayPal’s secure page.',
    bank_transfer: 'Bank details are shown after you order.',
    cash_on_delivery: 'Pay the courier on delivery.',
    open_account: 'Charged to your dealer account.',
  },
  paymentStatuses: {
    authorized: 'Authorized (on hold)',
    pending: 'Pending',
    requires_action: 'Under review',
    captured: 'Received',
    failed: 'Failed',
    cancelled: 'Cancelled',
    expired: 'Expired',
  },
  shipmentStatuses: {
    created: 'Preparing',
    in_transit: 'In transit',
    out_for_delivery: 'Out for delivery',
    delivered: 'Delivered',
    returned: 'Returned',
    exception: 'Delivery problem',
    cancelled: 'Cancelled',
  },
  carriers: {
    yurtici: 'Yurtiçi Kargo',
    aras: 'Aras Kargo',
    mng: 'MNG Kargo (DHL eCommerce)',
    ptt: 'PTT Kargo',
    surat: 'Sürat Kargo',
    hepsijet: 'HepsiJET',
    kolaygelsin: 'Kolay Gelsin',
    ups: 'UPS',
    other: 'Carrier',
  },
  paymentLink: {
    title: 'Payment',
    paid: 'Payment for this order has been received. Thank you.',
    validUntil: 'This payment link is valid until {{date}}.',
    recipient: 'Recipient: {{name}} · {{place}}',
    payButton: 'Pay by card',
  },
  legalKinds: {
    kvkk_notice: 'Privacy notice (KVKK)',
    membership_terms: 'Membership terms',
    pre_information: 'Pre-information form',
    distance_sales: 'Distance sales contract',
    return_policy: 'Returns and withdrawal',
    privacy_policy: 'Privacy policy',
    cookie_policy: 'Cookie policy',
  },
  units: {
    kg: 'kg',
    l: 'L',
    piece: 'piece',
  },
  // F7-19: düzenli gönderim
  addressBook: {
    title: 'My addresses',
    lead: 'Delivery addresses you can pick at checkout. Regular delivery uses your default delivery address.',
    empty: 'You have no saved addresses.',
    add: 'Add a new address',
    save: 'Save address',
    saved: 'Address saved.',
    cancel: 'Cancel',
    default: 'Default delivery',
    makeDefault: 'Make default',
    defaultSaved: 'Default delivery address changed.',
    setDefault: 'Make this my default delivery address',
    delete: 'Delete',
    deleteFor: 'Delete address {{name}}, {{city}}',
    deleteConfirm: 'Delete this address? Regular deliveries already started keep using their copy of it.',
    deleted: 'Address deleted.',
  },
  subscription: {
    title: 'Deliver regularly',
    discount: '{{pct}}% off every repeat order',
    terms:
      'Your first order is opened right away and you go to the payment page. Later orders are opened at the interval you choose, at the current price; we email the payment link and show it in My account, and your card is not stored. You can skip, postpone or cancel at any time.',
    interval: 'Delivery frequency',
    everyWeek: 'Every week',
    every: 'Every {{n}} weeks',
    start: 'Start regular delivery',
    signIn: 'Sign in to deliver regularly',
    addAddress: 'Add a delivery address in My account',
  },
  subscriptions: {
    title: 'My repeat orders',
    lead: 'See the next day of your regular deliveries; skip, postpone, pause or cancel them. You confirm and pay each order yourself via its payment link.',
    linkLead: 'Next delivery, skip, postpone, cancel',
    signIn: 'Sign in to see your repeat orders.',
    empty: 'You have no repeat orders. You can start one from the "Deliver regularly" box on a product page.',
    statuses: {
      active: 'Active',
      paused: 'Paused',
      cancelled: 'Cancelled',
    },
    reasons: {
      customer: 'At your request',
      unpaid: 'Paused because two orders in a row were not paid',
      unavailable: 'This product is no longer sold for regular delivery',
      panel: 'Cancelled by the store',
      payment_unavailable: 'The payment link could not be created; please contact the store',
    },
    summary: 'Quantity: {{quantity}} · {{interval}}',
    next: 'Next order: {{date}}',
    address: 'Delivery: {{address}}',
    pending: 'Order {{number}} is awaiting payment ({{total}}).',
    pay: 'Pay now',
    redirecting: 'Taking you to the payment page…',
    saved: 'Delivery frequency updated.',
    skip: 'Skip next',
    skipped: 'Next order skipped.',
    postponeDate: 'New date',
    postpone: 'Postpone',
    postponed: 'Next order postponed.',
    pause: 'Pause',
    paused: 'Regular delivery paused.',
    resume: 'Resume',
    resumed: 'Regular delivery resumed.',
    cancel: 'Cancel',
    cancelled: 'Regular delivery cancelled.',
    cancelConfirm:
      'Cancel this regular delivery? No new orders will be opened. An order awaiting payment is cancelled automatically when its link expires.',
  },
};
